import { createMemo } from '@packages/react';
import { applyRef } from '@packages/react/applyRef';
import * as React from 'react';
import { PositionedBox, PositionedBoxProps } from './PositionedBox';

export type FixedProps = PositionedBoxProps;

export const Fixed = createMemo<FixedProps>(
    // eslint-disable-next-line react/display-name
    React.forwardRef(({ ...props }, ref) => {
        applyRef(props, ref);
        return <PositionedBox {...props} />;
    }),
    {
        displayName: 'Fixed',
        defaultProps: {
            position: 'fixed',
        },
    },
);
